/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Chat} from '../../core/_models'

type Props = {
  chat: Chat
}

const UserInfoCell: FC<Props> = ({chat}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-40px overflow-hidden me-3'>
      <a href='#'>
        <div className='symbol-label'>
          <img
            src={toAbsoluteUrl(`/media/avatars/icons8-communication-96.png`)}
            alt={chat.messages?.length.toString()}
            className='w-75'
          />
        </div>
      </a>
    </div>
    <div>
    <div className='d-flex flex-column'>{chat._id}</div>
    <div className='line-clamp'>{ convertToPlain(chat?.messages?.at(-1)?.message)}</div>
    </div>
    
  </div>
)


function convertToPlain(html:any){

  // Create a new div element
  var tempDivElement = document.createElement("div");

  // Set the HTML content with the given value
  tempDivElement.innerHTML = html;

  // Retrieve the text property of the element 
  return tempDivElement.textContent || tempDivElement.innerText || "";
}

export {UserInfoCell}
